import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popupstudentgallry',
  templateUrl: './popupstudentgallry.component.html',
  styleUrls: ['./popupstudentgallry.component.css']
})
export class PopupstudentgallryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
